import React, { useContext, useEffect,useState } from "react";

const Waiting=()=>{
    return(
        <div>
            <h1>Account is waiting for approval</h1>
        </div>
        
    )
}

export default Waiting;